export default __webpack_public_path__ + "static/saber_background_large-876b6745e0ce1b4abedfa791c9e250ca.mp4";